import React from "react";
import dynamic from "next/dynamic";

import { useDispatch, useSelector } from "@/redux/hooks";
import { getShouldOpenLocationModal } from "@/redux/selectors/location";
import { cancelRequestLocation } from "@/redux/slices/location";

import { SidebarModal } from "./SidebarModal";

// This is being dynamically loaded so that any third party
// google maps scripts are not retrieved unless the user
// explicitly opens the location picker
const LocationPicker = dynamic(() => import("./LocationPicker"));

export const LocationPickerModal = ({
  returnFocusRef,
}: {
  returnFocusRef: React.RefObject<HTMLElement | null>;
}) => {
  const dispatch = useDispatch();
  const shouldOpen = useSelector(getShouldOpenLocationModal);

  const closeSidebarModal = () => {
    dispatch(cancelRequestLocation());
  };

  return (
    <SidebarModal
      open={shouldOpen}
      onCloseClick={closeSidebarModal}
      returnFocusRef={returnFocusRef}
    >
      {shouldOpen && <LocationPicker />}
    </SidebarModal>
  );
};
